import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps';
import TableComponent from '../../../components/table/TableOps';
import Remolque from './Remolque'



class Remolques extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'remolque/filter', deleteUrl: '', deleteField: 'Placa', modUrl: '/Catalogo/Remolque' },
      TableOp.Table('Remolques', [
        { label: 'Placa', id: 'Placa' },
        { label: 'Tipo', id: 'SubTipoRem' }, 
      ], [
        { id: 'edit', icon: 'edit' },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
        {
           
          <Remolque  onSave={() => {this.table()}} />
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(Remolques)